module.exports = __webpack_public_path__ + "assets/chat_filled-5ab7f5.svg";